import { render } from "./AnnouncePage.vue?vue&type=template&id=2ab7394f"
import script from "./AnnouncePage.vue?vue&type=script&lang=js"
export * from "./AnnouncePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__